import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { providersRoutes } from "./features/providers/providers-routing.module";
import { NewRetailerSmartComponent } from "./features/retailers/new-retailer/new-retailer-smart.component";
import { AuthGuard } from "./framework/crosscutting/authorization/auth.guard";
import { GuestGuard } from "./framework/crosscutting/authorization/guest.guard";
import { LayoutComponent } from "./layout/layout.component";
import { ForgotPasswordComponent } from "./layout/pages/forgot-password/forgot-password.component";
import { LoginComponent } from "./layout/pages/login/login.component";
import { LogoutComponent } from "./layout/pages/logout/logout.component";
import { PageNotFoundComponent } from "./layout/pages/page-not-found/page-not-found.component";
import { ResetPasswordComponent } from "./layout/pages/reset-password/reset-password.component";
import { VerifyComponent } from "./layout/pages/verify/verify.component";
import { ReportsComponent } from "./features/reports/reports.component";
import { AuthorizationService } from "./features-common/services/authorization.service";
import { ProductsComponent } from "./features/products/products.component";
import { ProvidersComponent } from "./features/providers/providers.component";
import { OverviewComponent } from "./features/overview/overview.component";
import { RetailerComponent } from "./features/retailers/retailer.component";
import { ManageUsersComponent } from "./features/manage-users/manage-users.component";
import { WalletComponent } from "./features/wallet/wallet.component";
import { PromotionsComponent } from "./features/promotions/promotions.component";
import { ProfileComponent } from "./features/profile/profile.component";
import { retailerRoutes } from "./features/retailers/retailer-routing.module";
import { reportsRoutes } from "./features/reports/reports-routing.module";
import { TermsAndConditionsComponent } from "./layout/pages/terms-and-conditions/terms-and-conditions.component";
import { ContactUsSmartComponent } from "./layout/pages/contact-us/contact-us-smart.component";
import { AboutUsComponent } from "./layout/pages/about-us/about-us.component";
import { ConsumersComponent } from "./features/consumers/consumers.component";
import { ConsumerReportComponent } from "./features/consumer-report/consumer-report.component";
import { consumerReportsRoutes } from "./features/consumer-report/consumer-report-routing.module";

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "verify",
    component: VerifyComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "logout",
    component: LogoutComponent,
    canActivate: [GuestGuard],
  },
  {
    path: "features",
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "terms-conditions",
        component: TermsAndConditionsComponent,
      },
      {
        path: 'about-us',
        component: AboutUsComponent
      },
      {
        path: "contact-us",
        component: ContactUsSmartComponent,
      },
      {
        path: "overview",
        component: OverviewComponent,
        loadChildren: async () =>
          (await import("./features/overview/overview.module")).OverviewModule,
      },
      {
        path: "retailers",
        component: RetailerComponent,
        children: [...retailerRoutes],
      },
      {
        path: "products",
        component: ProductsComponent,
        loadChildren: async () =>
          (await import("./features/products/products.module")).ProductsModule,
      },
      {
        path: "providers",
        component: ProvidersComponent,
        loadChildren: async () =>
          (await import("./features/providers/providers.module"))
            .ProvidersModule,
      },
      {
        path: "manage-users",
        component: ManageUsersComponent,
        loadChildren: async () =>
          (await import("./features/manage-users/manage-users.module"))
            .ManageUsersModule,
      },
      {
        path: "consumers",
        component: ConsumersComponent,
        loadChildren: async () =>
          (await import("./features/consumers/consumers.module"))
            .ConsumersModule,
      },
      {
        path: "wallet",
        component: WalletComponent,
        loadChildren: async () =>
          (await import("./features/wallet/wallet.module")).WalletModule,
      },
      {
        path: "reports",
        component: ReportsComponent,
        children: [...reportsRoutes],
      },
      {
        path: "consumer-reports",
        component: ConsumerReportComponent,
        children: [...consumerReportsRoutes],
      },
      {
        path: "promotions",
        component: PromotionsComponent,
        loadChildren: async () =>
          (await import("./features/promotions/promotions.module"))
            .PromotionsModule,
      },
      {
        path: "messages",
        loadChildren: async () =>
          (await import("./features/messages/messages.module")).MessagesModule,
      },
      {
        path: "retailer-portal",
        loadChildren: async () =>
          (await import("./features/retailer-portal/retailer-portal.module"))
            .RetailerPortalModule,
      },
      {
        path: "profile",
        component: ProfileComponent,
        loadChildren: async () =>
          (await import("./features/profile/profile.module")).ProfileModule,
      },
      {
        path: "",
        redirectTo: "overview",
        pathMatch: "full",
      },
    ],
  },
  {
    path: "",
    redirectTo: "features",
    pathMatch: "full",
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: "enabled" }),
  ],
  exports: [RouterModule],
  providers: [AuthorizationService],
})
export class AppRoutingModule {}
